import { useQuery } from '@tanstack/react-query';
import {
  apiShopsGetCollection,
  apiShopsShopIdproductsGetCollection
} from '@r/api/generated/client.ts';
import {
  ShopShopReadModelType,
  type ProductProductReadModel,
  type ShopShopReadModel
} from '@r/api/generated/client.schemas.ts';

/** IRI produit pour les payloads API (catalogue boutique → sous-ressource shop). */
export function getRewardProductIri(productId: number, shopId: number): string {
  return `/shops/${shopId}/products/${productId}`;
}

/** Parcourt la collection boutiques jusqu’à trouver la boutique de type reward. */
async function findRewardShopInCollection(): Promise<number | null> {
  let page = 1;
  let lastPage = 1;

  do {
    const response = await apiShopsGetCollection({ page, perPage: 30 });
    const rewardShop = response.data?.find(
      (shop: ShopShopReadModel) => shop.type === ShopShopReadModelType.reward
    );
    if (rewardShop?.id != null) {
      return rewardShop.id;
    }
    lastPage = response.pagination?.last ?? page;
    page += 1;
  } while (page <= lastPage);

  return null;
}

/** ID de la boutique reward du workspace (requise pour lier un produit à une récompense palier). */
export function useRewardShopId(enabled: boolean) {
  return useQuery({
    queryKey: ['admin', 'reward-shop-id'],
    enabled,
    queryFn: findRewardShopInCollection
  });
}

/** Catalogue paginé de la boutique reward, produits archivés exclus. */
async function fetchAllRewardShopProducts(shopId: number): Promise<ProductProductReadModel[]> {
  const products: ProductProductReadModel[] = [];
  let page = 1;
  let lastPage = 1;

  do {
    const response = await apiShopsShopIdproductsGetCollection(String(shopId), {
      page,
      perPage: 30
    });
    products.push(...(response.data ?? []));
    lastPage = response.pagination?.last ?? page;
    page += 1;
  } while (page <= lastPage);

  return products.filter((product) => !product.isArchived);
}

/** Produits sélectionnables dans la modale « associer une récompense ». */
export function useRewardShopProducts(shopId: number | null | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['admin', 'reward-shop-products', shopId],
    enabled: enabled && shopId != null,
    queryFn: () => fetchAllRewardShopProducts(shopId as number)
  });
}
